export const footerElements = [
    {
        id: 1,
        title : "PS Studio créative",
        sub : [
            {
                name: "Shooting photo pro",
                link: "/services/pscreative#Shooting photo pro",
                short_id: "creationpagesShooting photo pro",
            },
            {
                name: "Couverture des mariages",
                link: "/services/pscreative#Couverture des mariages",
                short_id: "Couverture des mariages",
            },
            {
                name: "Réalisation de spots vidéo",
                link: "/services/pscreative#Réalisation de spots vidéo",
                short_id: "Réalisation de spots vidéo",
            },
            {
                name: "Clip vidéo",
                link: "/services/pscreative#Clip vidéo",
                short_id: "Clip vidéo",
            },
            {
                name: "Films & Court métrage",
                link: "/services/pscreative#Films & Court métrage",
                short_id: "Films & Court métrage",
            },
            {
                name: "Formation dans les métiers audiovisuel",
                link: "/services/pscreative#Formation dans les métiers audiovisuel",
                short_id: "Formation dans les métiers audiovisuel",
            },
        ],
    },
    {
        id: 2,
        title : "PS Digital",
        sub : [
            {
                name: "Creation et gestion des pages resaux sociaux",
                link: "/services/psdigital#creationpages",
                short_id: "creationpages",
            },
            {
                name: "Validation des comptes",
                link: "/services/psdigital#validationcomptes",
                short_id: "validationcomptes",
            },
            {
                name: "Sponsoring & Boost",
                link: "/services/psdigital#sponsoring",
                short_id: "sponsoring",
            },
            {
                name: "Monétisation des comptes",
                link: "/services/psdigital#Validation et Monétisation de comptes",
                short_id: "Validation et Monétisation de comptes",
            },
            {
                name: "Developement Web",
                link: "/services/psdigital#webdevelopment",
                short_id: "webdevelopment",
            },
            {
                name: "Infographie & Print",
                link: "/services/psdigital#infrographie",
                short_id: "infrographie",
            },
            {
                name: "Creation des logos et flyers",
                link: "/services/psdigital#Creation des logos et flyers"
            },
            {
                name: "Hebergement Web",
                link: "/services/psdigital#hosting",
                short_id: "Creation des logos et flyers",
            },
            {
                name: "Filtre SNAPCHAT",
                link: "/services/psdigital#filtresnapchat",
                short_id: "filtresnapchat",
            },
            {
                name: "Modélisation 2D & 3D",
                link: "/services/psdigital#modelisation2D3D",
                short_id: "modelisation2D3D",
            },
        ],
    },
    {
        id: 3,
        title : "PSG ZIK",
        sub : [
            {
                name: "Production et management d'artistes",
                link: "/services/psgzik#Production et management d'artistes",
                short_id: "Production et management d'artistes",
            },
            {
                name: "Communication musicale",
                link: "/services/psgzik#Communication musicale",
                short_id: "Communication musicale",
            },
            {
                name: "Enregistrement & Mastering",
                link: "/services/psgzik#Enregistrement & Mastering",
                short_id: "Enregistrement & Mastering",
            },
            {
                name: "Distribution musicale",
                link: "/services/psgzik#Distribution musicale",
                short_id: "Distribution musicale",
            },
            {
                name: "Facilitation",
                link: "/services/psgzik#Facilitation",
                short_id: "Facilitation",
            },
        ],
    },
    {
        id: 4,
        title : "AFRIJEUNE TV",
        sub : [
            {
                name: "Publicités",
                link: "/services/afrijeunetv#Publicités",
                short_id: "Publicités",
            },
            {
                name: "Communication télévisée",
                link: "/services/afrijeunetv#Communication télévisée",
                short_id: "Communication télévisée",
            },
            {
                name: "Nos émissions",
                link: "/services/afrijeunetv#Nos émissions",
                short_id: "Nos émissions",
            },
            {
                name: "Reportages",
                link: "/services/afrijeunetv#Reportages",
                short_id: "Reportages",
            },
            {
                name: "Interviews",
                link: "/services/afrijeunetv#Interviews",
                short_id: "Interviews",
            },
        ],
        
    },
]